export default "__VITE_ASSET__BUjFjv4n__"